(function () {
  class PdpIngredientsModal {
    constructor(root) {
      this.root = root;
      this.modal = root.querySelector('[data-pdp-ingredients-modal]');
      this.image = root.querySelector('[data-pdp-ingredients-image]');
      this.openBtn = root.querySelector('.pdp-gallery-extras__ingredients-btn');
      this.closeBtn = root.querySelector('[data-pdp-ingredients-close]');
      this.overlay = root.querySelector('[data-pdp-ingredients-overlay]');
      this.sectionId = root.dataset.sectionId;

      const dataEl = root.querySelector('[data-pdp-ingredients-variants]');
      this.variantData = dataEl ? JSON.parse(dataEl.textContent) : { byId: {}, byOption: {}, variantOptions: {} };
      this.currentVariantId = root.dataset.currentVariantId;

      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentChange = this.onDocumentChange.bind(this);
      this.onVariantImageChanged = this.onVariantImageChanged.bind(this);

      this.init();
    }

    portalModalToBody() {
      if (!this.modal || this.modal.parentElement === document.body) return;
      document.body.appendChild(this.modal);
    }

    getImageUrl(variantId) {
      const id = String(variantId);
      const byId = this.variantData.byId || {};
      if (byId[id]) return byId[id];

      const optionKey = (this.variantData.variantOptions || {})[id];
      if (optionKey && (this.variantData.byOption || {})[optionKey]) {
        return this.variantData.byOption[optionKey];
      }

      return null;
    }

    setImageSource(url) {
      if (!this.image) return;

      this.image.removeAttribute('srcset');
      this.image.removeAttribute('sizes');

      if (url) {
        this.image.src = url;
        this.image.removeAttribute('hidden');
        this.image.hidden = false;
      } else {
        this.image.removeAttribute('src');
        this.image.hidden = true;
      }
    }

    updateImage(variantId) {
      if (variantId) this.currentVariantId = String(variantId);

      const url = this.getImageUrl(this.currentVariantId);
      this.setImageSource(url);

      if (this.openBtn) {
        this.openBtn.disabled = !url;
        this.openBtn.setAttribute('aria-disabled', url ? 'false' : 'true');
      }

      if (!url && this.modal?.classList.contains('is-open')) {
        this.close();
      }
    }

    open() {
      if (!this.modal || !this.getImageUrl(this.currentVariantId)) return;

      this.portalModalToBody();
      this.modal.hidden = false;
      this.modal.classList.add('is-open');
      document.body.classList.add('pdp-ingredients-modal-open');
      document.addEventListener('keydown', this.onKeydown);
      this.closeBtn?.focus();
    }

    close() {
      if (!this.modal) return;

      this.modal.hidden = true;
      this.modal.classList.remove('is-open');
      document.body.classList.remove('pdp-ingredients-modal-open');
      document.removeEventListener('keydown', this.onKeydown);
      this.openBtn?.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    onDocumentChange(event) {
      const vvbInput = event.target.closest?.('.vvb-variant-input');
      if (vvbInput?.value) {
        this.updateImage(vvbInput.value);
        return;
      }

      if (event.target.name === 'id' && event.target.value) {
        this.updateImage(event.target.value);
      }
    }

    onVariantImageChanged(event) {
      const variantId = event.detail?.variantId;
      if (variantId) this.updateImage(variantId);
    }

    bindVariantListeners() {
      document.addEventListener('change', this.onDocumentChange, true);

      document.addEventListener('variant:imageChanged', this.onVariantImageChanged);
      document.addEventListener('variantImageSelected', this.onVariantImageChanged);
      document.addEventListener('variant:changed', this.onVariantImageChanged);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant;
          if (!variant?.id) return;
          if (this.sectionId && event.data.sectionId && event.data.sectionId !== this.sectionId) return;
          this.updateImage(variant.id);
        });
      }
    }

    init() {
      this.portalModalToBody();
      this.updateImage(this.currentVariantId);

      this.openBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });

      this.closeBtn?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());

      this.bindVariantListeners();
    }
  }

  function initPdpIngredientsModals() {
    document.querySelectorAll('[data-pdp-ingredients-root]').forEach((root) => {
      if (!root.__pdpIngredientsModal) {
        root.__pdpIngredientsModal = new PdpIngredientsModal(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpIngredientsModals);
  } else {
    initPdpIngredientsModals();
  }
})();
